const getters = {
    purchases: (state) => state.purchases,
    links: (state) => state.links,
    page: (state) => state.page,
    isRequesting: (state) => state.isRequesting,

}
export default getters
